import styled from "styled-components"
import { device } from "breakpoints"
import { Button } from "ui/Button"

export const InternalNavContainer = styled.div`
  width: 100%;
  position: relative;
`